"use client";

import FooterButton from "@/components/FooterButton";
import DiscordIcon from "@/components/image-component/discord-icon";
import XIcon from "@/components/image-component/x-icon";
import PrimaryButton from "@/components/PrimaryButton";
import { useTrackUserEvent } from "@/utils/analytics";
import Image from "next/image";
import { PropsWithChildren } from "react";
import {
  Blobbie,
  useActiveAccount,
  useActiveWallet,
  useAutoConnect,
  useConnectModal,
  useDisconnect,
  useWalletDetailsModal,
} from "thirdweb/react";
import { shortenAddress } from "thirdweb/utils";
import { chain, thirdWebClient, wallets } from "./libs/thirdweb";

export function LayoutClient({ children }: PropsWithChildren) {
  const { connect, isConnecting } = useConnectModal();
  const { disconnect } = useDisconnect();
  const wallet = useActiveWallet();

  const activeAccount = useActiveAccount();
  const detailsModal = useWalletDetailsModal();

  // const [isEligible, setIsEligible] = useState<boolean>(false);
  // const [isNonEvmEligible, setIsNonEvmEligible] = useState<boolean>(false);
  // const [linkedWalletDetails, setLinkedWalletDetails] = useState(null);

  const trackUserEvent = useTrackUserEvent();

  useAutoConnect({
    client: thirdWebClient,
    wallets,
  });

  const onClick = async () => {
    if (isConnecting) return;

    const wallet = await connect({
      client: thirdWebClient,
      wallets,
      size: "compact",
    });
    await wallet?.switchChain(chain);
  };

  const handleClick = () => {
    detailsModal.open({ client: thirdWebClient, theme: "dark" });
  };

  const twitterText = process.env.NEXT_PUBLIC_TWITTER_TEXT || "58.7K";
  const discordText = process.env.NEXT_PUBLIC_DISCORD_TEXT || "47K";
  // const githubText = process.env.NEXT_PUBLIC_GITHUB_TEXT || "196";
  // const linkedinText = process.env.NEXT_PUBLIC_LINKEDIN_TEXT || "7K";

  const footerButtons = [
    {
      id: 1,
      title: "X",
      text: twitterText,
      onClick: () => window.open("https://x.com/spheron"),
      icon: <XIcon />,
    },
    {
      id: 2,
      title: "Dicord",
      text: discordText,
      onClick: () => window.open("https://sphn.wiki/discord"),
      icon: <DiscordIcon />,
    },
    // {
    //   id: 2,
    //   title: "Github",
    //   text: githubText,
    //   onClick: () => window.open("https://github.com/spheronFdn"),
    //   icon: <GithubIcon />,
    // },
    // {
    //   id: 3,
    //   title: "LinkedIn",
    //   text: linkedinText,
    //   onClick: () => window.open("https://sphn.wiki/linkedin"),
    //   icon: <LinkedinIcon />,
    // },
  ];

  return (
    <main className="bg-transparent">
      <div className="lg:min-h-[calc(100vh-80px)]">
        <div className="flex flex-row justify-between px-4 lg:px-[74px] py-3 h-[80px]">
          <div
            className="cursor-pointer"
            onClick={() => {
              window.open("https://spheron.network");
            }}
          >
            <Image
              src="/spheron-logo.svg"
              alt="spheron logo"
              width="100"
              height="34"
            />
          </div>
          <div className="flex items-center gap-6">
            {/* <div
              onClick={() => {
                trackUserEvent("Buy SPON Click");
              }}
              className="flex items-center gap-10 font-jetbrans-mono text-white text-base hover:underline cursor-pointer"
            >
              BUY $SPON
            </div> */}

            {activeAccount?.address && (
              <div
                onClick={handleClick}
                className={`hidden lg:flex gap-x-2 items-center text-white text-base font-normal font-jetbrans-mono leading-none cursor-pointer px-4 py-3`}
              >
                <Blobbie
                  style={{
                    borderRadius: "50%",
                  }}
                  size={32}
                  address={activeAccount.address}
                />
                <span>{shortenAddress(activeAccount.address)}</span>
                <span className="opacity-30 text-white">|</span>
                <button
                  className="uppercase hover:underline"
                  onClick={() => {
                    if (wallet) {
                      disconnect(wallet);
                      trackUserEvent("Disconnected Wallet Click");
                    }
                  }}
                >
                  Disconnect
                </button>
              </div>
            )}
            {!activeAccount?.address && (
              <div className="lg:w-[18vw] hidden lg:block grow-0 relative h-full">
                <PrimaryButton
                  variant="dark"
                  className="rounded-tr-md"
                  onClick={() => {
                    trackUserEvent("Navbar Connect Click");
                    onClick();
                  }}
                >
                  Connect Your Wallet
                </PrimaryButton>
              </div>
            )}
          </div>
        </div>
        <div className="mx-auto lg:min-w-[1000px] lg:w-[45vw] w-[90vw] flex flex-col items-center">
          {children}
        </div>
      </div>
      <footer className="mt-[100px] lg:px-[74px] px-4 w-full py-4">
        <div
          className="flex flex-col gap-3 items-center lg:flex-row lg:justify-between
        space-y-2 font-normal text-xs font-sans text-white
        w-content-mobile lg:w-content"
        >
          <div>
            {/* <a
          href="./Spheron_Website_Terms_of_Use.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Privacy Policy
        </a>{" "}
        .{" "} */}
            <a
              href="/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Terms of Conditions
            </a>
          </div>
          <div className="flex flex-row gap-2">
            {footerButtons.map((buttonContent) => (
              <FooterButton
                key={buttonContent.id}
                onClick={() => {
                  buttonContent.onClick();
                }}
                className="w-max text-protocolNew-base
              hover:bg-protocolNew-base hover:text-white 
              duration-300 ease-out"
              >
                <div className="flex gap-2 items-center text-xs font-normal">
                  {buttonContent.icon}
                  <span>{buttonContent.text}</span>
                </div>
              </FooterButton>
            ))}
          </div>
        </div>
      </footer>
    </main>
  );
}
